module.exports = __webpack_public_path__ + "img/example.2e2bab07.jpeg";